/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import {
  Grid,
  ImageList,
  ImageListItem,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Iconify from "../../../../components/iconify";
import moment from "moment";
import { useEffect, useLayoutEffect, useState } from "react";
import { usePersistentState } from "../../../../contexts/global-context";
import { GetLocalStorage } from "../../../../utils/local-storage";
import NumberFormat from "../../../../components/number-format";
import { Parser } from "html-to-react";
const EventVenueProps = {
  City: "",
  AddressLine1: "",
  Country: "",
  ZipCode: "",
  State: "",
  id: 0,
  venue: "",
  timezone: null,
};
interface formDataTypes {
  title?: string;
  organizerId?: null;
  description?: string;
  eventCategoryId?: null;
  VideoUrl?: string;
}
const coverImagesProps = {
  name: "",
  data: "",
  id: 0,
};
interface coverImagesPropsTypes {
  name?: string;
  data: string;
  id?: number;
}
const formData = {
  title: "",
  organizerId: null,
  description: "",
  imageBase64: "",
  imageBase64Other: "",
  eventCategoryId: null,
  VideoUrl: "",
};

function srcset(image: string, size: number, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${size * cols}&h=${
      size * rows
    }&fit=crop&auto=format&dpr=2 2x`,
  };
}

const EventSummery = () => {
  const [, dispatch]: any = usePersistentState();
  const [coverImages, setCoverImages] =
    useState<coverImagesPropsTypes>(coverImagesProps);
  const [otherImages, setOtherImages] = useState<
    { name: string; data: string; id: number }[]
  >([]);

  const [eventDetail, setEventDetail] = useState<formDataTypes>(formData);
  const [eventVenue, setEventVenue] = useState<any>(EventVenueProps);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [eventSchedule, setEventSchedule] = useState<
    { startDate: ""; endDate: ""; id: 0; isDisabled: boolean }[]
  >([{ startDate: "", endDate: "", id: 0, isDisabled: false }]);
  const [eventFaq, setEventFaq] = useState<
    {
      title: string;
      description: string;
      ordering: string;
      id?: string;
      isDisabled?: boolean;
    }[]
  >([{ title: "", description: "", ordering: "", id: "", isDisabled: false }]);
  const [ticketTypeConfig, setTicketTypeConfig] = useState<
    {
      TicketType: string;
      ShortDesc: string;
      Price: string;
      QuantityAvailable: string;
      SaleStartDateTime: string;
      SaleEndDateTime: string;
      Ordering: string;
      PerOrderLimit: string;
      IsSoldOut: boolean;
      isDisabled: boolean;
      id: number;
    }[]
  >([
    {
      TicketType: "",
      ShortDesc: "",
      Price: "",
      QuantityAvailable: "",
      SaleStartDateTime: "",
      SaleEndDateTime: "",
      Ordering: "",
      PerOrderLimit: "",
      IsSoldOut: false,
      isDisabled: false,
      id: 0,
    },
  ]);
  const organizerId: any = eventDetail.organizerId;
  const eventCategoryId: any = eventDetail.eventCategoryId;
  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  useEffect(() => {
    let temp: any = localStorage.getItem("eventDetails");
    let newData = JSON.parse(temp);
    let eventDetailNewData = eventDetail;
    eventDetailNewData.title = newData?.title;
    eventDetailNewData.organizerId = newData?.organizer;
    eventDetailNewData.eventCategoryId = newData?.eventCategory;
    eventDetailNewData.description = newData?.description;
    eventDetailNewData.VideoUrl = newData?.videoUrl;
    setEventDetail(eventDetailNewData);
    let coverImage = newData?.eventBanners.map((x: any) => {
      if (!x?.isCoverdImage) return;
      let newData = {
        data: x?.filePath,
        name: "",
        id: x?.id,
      };
      return newData;
    });
    let otherImages: [] = newData?.eventBanners.map((x: any) => {
      if (x?.isCoverdImage) return;

      let newData = {
        data: x?.filePath,
        name: "",
        id: x?.id,
      };
      return newData;
    });
    const finalCoverImage = coverImage?.find((item: any) => item !== undefined);
    setCoverImages(finalCoverImage);
    const newArrayOtherImages = otherImages.filter(
      (item) => item !== undefined
    );
    setOtherImages(newArrayOtherImages);
  }, [coverImages?.data]);

  useEffect(() => {
    const image = new Image();
    image.src = coverImages?.data;
  }, [coverImages?.data]);
  useEffect(() => {
    let tempVenue: any = GetLocalStorage("eventVenue");
    let newEventCustom = eventVenue;
    newEventCustom.City = tempVenue?.city;
    newEventCustom.id = tempVenue?.id;
    newEventCustom.State = tempVenue?.state;
    newEventCustom.AddressLine1 = tempVenue?.address1;
    newEventCustom.ZipCode = tempVenue?.zipCode;
    newEventCustom.Country = tempVenue?.country;
    newEventCustom.venue = tempVenue?.venue;
    newEventCustom.timezone = tempVenue?.timeZone;

    setEventVenue(newEventCustom);
    let tempEventSchedule: any = GetLocalStorage("eventSchedule");

    if (tempEventSchedule) {
      let newEventSchedule = tempEventSchedule?.map((x: any) => {
        return {
          startDate: x?.startDate,
          endDate: x?.endDate,
          id: x?.id,
          isDisabled: x?.isDisabled,
        };
      });

      setEventSchedule(newEventSchedule);
    }
  }, []);

  useEffect(() => {
    let temp: any = GetLocalStorage("eventTicketConfig");
    if (temp) {
      let finalData = temp?.map((x: any) => {
        return {
          ShortDesc: x?.description,
          Price: x?.price,
          QuantityAvailable: x?.quantity,
          SaleEndDateTime: x?.saleEndDate,
          SaleStartDateTime: x?.saleStartDate,
          TicketType: x?.ticketType,
          Ordering: x?.ordering,
          PerOrderLimit: x?.perOrderLimit,
          IsSoldOut: x?.isSoldOut,
          id: x?.id,
          isDisabled: x?.isDisabled,
        };
      });
      setTicketTypeConfig(finalData);
    }
  }, []);

  useEffect(() => {
    let temp: any = GetLocalStorage("eventFaq");
    if (temp) {
      let newData: { title: string; description: string; ordering: string }[] =
        temp?.map((x: any) => {
          return {
            title: x?.title,
            description: x?.description,
            eventId: x?.eventId,
            ordering: x?.ordering,
            id: x?.id,
            isDisabled: x?.isDisabled,
          };
        });
      setEventFaq(newData);
    }
  }, []);

  const handleEditClick = (sectionIndex: any) => {
    dispatch({ WizardKey: sectionIndex });
  };

  return (
    <div style={{ width: "100%", marginTop: 70 }}>
      <Grid container xs={12}>
        <Grid xs={12}>
          <Paper
            elevation={3}
            style={{
              padding: "16px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Event Detail
              </Typography>
              <Link
                style={{ margin: "0 0 4px 5px" }}
                component="button"
                variant="body2"
                onClick={() => handleEditClick(0)}
              >
                <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
              </Link>
            </div>
            <TableContainer component={Paper}>
              <Table>
                <TableRow>
                  <TableCell></TableCell>

                  <TableCell>
                    <img
                      src={coverImages?.data}
                      style={{ width: "30%", marginTop: 2 }}
                      alt=""
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Title</TableCell>
                  <TableCell>{eventDetail.title}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Organizer</TableCell>
                  <TableCell>{organizerId?.firstName}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Event Category</TableCell>
                  <TableCell>{eventCategoryId?.name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Description</TableCell>
                  <TableCell>
                    {Parser().parse(
                      eventDetail?.description ? eventDetail?.description : " "
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Other image</TableCell>
                  <TableCell>
                    <ImageList
                      sx={{ width: "auto" }}
                      variant="masonry"
                      cols={isSmallScreen ? 2 : 4}
                      rowHeight={isSmallScreen ? "auto" : "auto"}
                    >
                      {otherImages?.map((item: any, index: any) => (
                        <ImageListItem
                          key={index}
                          cols={item?.cols || 1}
                          rows={item?.rows || 1}
                        >
                          <img
                            {...srcset(item?.data, 121, item?.rows, item?.cols)}
                            loading="lazy"
                          />
                        </ImageListItem>
                      ))}
                    </ImageList>
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
        <Grid xs={12}>
          <Paper
            elevation={3}
            style={{
              padding: "16px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Venue
              </Typography>
              <Link
                style={{ margin: "0 0 4px 5px" }}
                component="button"
                variant="body2"
                onClick={() => handleEditClick(1)}
              >
                <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
              </Link>
            </div>
            {eventVenue?.venue === "" || eventVenue?.venue === null ? (
              <TableContainer component={Paper}>
                <Table>
                  <TableRow>
                    <TableCell>Address</TableCell>
                    <TableCell
                      style={{
                        borderRadius: 10,
                        width: "100%",
                      }}
                    >
                      {eventVenue?.AddressLine1}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>City</TableCell>
                    <TableCell
                      style={{
                        borderRadius: 10,
                        width: "100%",
                      }}
                    >
                      {eventVenue?.City}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>State</TableCell>
                    <TableCell
                      style={{
                        borderRadius: 10,
                        width: "100%",
                      }}
                    >
                      {eventVenue?.State}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Country</TableCell>
                    <TableCell
                      style={{
                        borderRadius: 10,
                        width: "100%",
                      }}
                    >
                      {eventVenue?.Country}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>ZipCode</TableCell>
                    <TableCell
                      style={{
                        borderRadius: 10,
                        width: "100%",
                      }}
                    >
                      {eventVenue?.ZipCode}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>TimeZone</TableCell>
                    <TableCell
                      style={{
                        borderRadius: 10,
                        width: "100%",
                      }}
                    >
                      {eventVenue?.timezone?.timeZoneName}
                    </TableCell>
                  </TableRow>
                </Table>
              </TableContainer>
            ) : (
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    <div
                      style={{
                        borderRadius: 10,
                        width: "100%",
                      }}
                    >
                      <TableRow>
                        <TableCell>Address</TableCell>
                        <TableCell
                          style={{
                            borderRadius: 10,
                            width: "100%",
                          }}
                        >
                          {eventVenue?.venue}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>TimeZone</TableCell>
                        <TableCell
                          style={{
                            borderRadius: 10,
                            width: "100%",
                          }}
                        >
                          {eventVenue?.timezone?.timeZoneName}
                        </TableCell>
                      </TableRow>
                    </div>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "20px 0 10px 0",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Schedule
              </Typography>
              <Link
                style={{ margin: "0 0 4px 5px" }}
                component="button"
                variant="body2"
                onClick={() => handleEditClick(1)}
              >
                <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
              </Link>
            </div>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  <TableRow
                    style={{
                      background: "#cccccc",
                    }}
                  >
                    <TableCell style={{ widows: "100%" }}>Start Date</TableCell>

                    <TableCell style={{ widows: "100%" }}>End Date</TableCell>
                  </TableRow>
                  {eventSchedule?.map((item: any, index: any) => {
                    if (item?.isDisabled === true) return;
                    return (
                      <TableRow key={index}>
                        <TableCell>
                          {moment(item.startDate).format(
                            "MMM DD, YYYY - h:mm A"
                          )}
                        </TableCell>

                        <TableCell>
                          {moment(item.endDate).format("MMM DD, YYYY - h:mm A")}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>

        <Grid xs={12} style={{ marginTop: "5px" }}>
          <Paper
            elevation={3}
            style={{
              padding: "16px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Ticket Config
              </Typography>
              <Link
                style={{ margin: "0 0 4px 5px" }}
                component="button"
                variant="body2"
                onClick={() => handleEditClick(2)}
              >
                <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
              </Link>
            </div>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  <TableRow style={{ background: "#cccccc" }}>
                    <TableCell>Ticket Type</TableCell>
                    <TableCell>Sort Desc</TableCell>
                    <TableCell>Price</TableCell>
                    <TableCell>Quantity Available</TableCell>
                    <TableCell>Ordering</TableCell>
                    <TableCell>Per Order Limit</TableCell>
                    <TableCell>Sale Start Date</TableCell>
                    <TableCell>Sale End Date</TableCell>
                  </TableRow>
                  {ticketTypeConfig?.map((item: any, index: any) => {
                    if (item?.isDisabled === true) return;
                    return (
                      <TableRow key={index}>
                        <TableCell>{item.TicketType}</TableCell>
                        <TableCell>{item.ShortDesc}</TableCell>
                        <TableCell>
                          $<NumberFormat total={item.Price} />
                        </TableCell>
                        <TableCell>{item.QuantityAvailable}</TableCell>

                        <TableCell>{item.Ordering}</TableCell>
                        <TableCell>{item.PerOrderLimit}</TableCell>
                        {item.SaleStartDateTime === null ? (
                          <TableCell>-</TableCell>
                        ) : (
                          <TableCell>
                            {" "}
                            {moment(item.SaleStartDateTime).format(
                              "MMM DD, YYYY - h:mm A"
                            )}
                          </TableCell>
                        )}

                        {item.SaleEndDateTime === null ? (
                          <TableCell>-</TableCell>
                        ) : (
                          <TableCell>
                            {moment(item.SaleEndDateTime).format(
                              "MMM DD, YYYY - h:mm A"
                            )}
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            style={{
              padding: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography variant="h6" gutterBottom>
                FAQ
              </Typography>
              <Link
                style={{ margin: "0 0 4px 5px" }}
                component="button"
                variant="body2"
                onClick={() => handleEditClick(3)}
              >
                <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
              </Link>
            </div>

            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  <TableRow
                    style={{
                      background: "#cccccc",
                    }}
                  >
                    <TableCell style={{ width: "25%" }}>Title</TableCell>

                    <TableCell style={{ width: "25%" }}>Ordering</TableCell>
                    <TableCell style={{ width: "50%" }}>Description</TableCell>
                  </TableRow>
                  {eventFaq?.map((item: any, index: any) => {
                    if (item?.isDisabled === true) return;

                    return (
                      <TableRow key={index}>
                        <TableCell style={{ width: "25%" }}>
                          {item.title}
                        </TableCell>
                        <TableCell style={{ width: "25%" }}>
                          {item.ordering}
                        </TableCell>
                        <TableCell style={{ width: "50%" }}>
                          {item.description}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};
export default EventSummery;
